export const STEPS = [1, 2, 3, 4]
